import * as actionTypes from "./actionTypes";


export const navigationUpdateHeaderSuffix = (text) => {
    return {
        type: actionTypes.NAVIGATION_UPDATE_HEADER_SUFFIX,
        text: text
    }
};